<template>
    <div class="dm-finish-account-setup-form">
		<h5 class="border-bottom fw-bold pb-3 mb-4">Password</h5>
		<SetPasswordForm
			:user_data="userData" />

		<div class="text-center">
			<button 
				class="btn mt-3 mb-4 dm-btn-padding dm-view-as-pdf"
				:class="{ 'disabled' : !canSubmit }"
				:disabled="!canSubmit"
				@click="submit()">Set Password</button>
		</div>

	</div>
</template>

<script>
import SetPasswordForm from '../user/partials/SetPasswordForm.vue';
import CategoryPreferences from '../../../shared/taxonomies/CategoryPreferences.vue';

export default {
	props: ['token'],
    components: { SetPasswordForm, CategoryPreferences },

	computed: {
		canSubmit() {
			if (this.userData.password.length < 8) return false;
			if (this.userData.password != this.userData.password_confirmation) return false;

			return true;
		}
	},

	data() {
		return {
			userData: {
				token: this.token,
				password: '',
				password_confirmation: '',
			}
		}
	},

	methods: {
		submit() {
			var self = this;
			
			axios.post('/set-up-password', this.userData)
				.then(function (response) {
					if (response && response.data && response.data.redirect_to)
						self.showPasswordSetPopup(response.data.redirect_to);
				})
				.catch(function (error) {
					console.log(error);            
				});

		},

		showPasswordSetPopup(redirectTo) {
			var self = this;
			this.$swal({
				text: 'Password set successfuly',
				icon: "success",
			}).then(function () {
				self.redirectToEditorDashboard(redirectTo)
			});
		},

		redirectToEditorDashboard(redirectTo) {
			window.location.href = redirectTo;
		}
		
	}
}
</script>
